import React, { useState } from 'react';
import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Collapse,
  AutoComplete,
  Select,
  DatePicker,
} from 'antd';
import 'moment/locale/fr-ca';
import locale from 'antd/es/date-picker/locale/fr_CA';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
const { Panel } = Collapse;
const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';
const FilterLogs = ({
  contactsChantier,
  getLogs,
  resultsNumber,
  loading,
  reset,
}) => {
  const [form] = Form.useForm();
  const getFields = () => {
    const children = (
      <>
        <Form.Item name={`destinataires`} label={`Destinataires :`} rules={[]}>
          {/* <Input placeholder="Nom de l'employé" /> */}
          <Select
            mode="multiple"
            allowClear
            placeholder="Sélectionnez des employés">
            {contactsChantier.map((contact) => (
              <Option
                key={contact.key}
                value={contact.nom + ' ' + contact.prenom}>
                {contact.nom + ' ' + contact.prenom}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name={`date`}
          label={`Date :`}
          rules={[
            {
              required: true,
              message: 'Veuillez indiquer une date de début et une date de fin',
            },
          ]}>
          {/* <Input placeholder="Nom de l'employé" /> */}
          <RangePicker
            //style={{ width: '100%' }}
            locale={locale}
            allowClear
            format={dateFormat}
          />
        </Form.Item>
      </>
    );
    return children;
  };
  const onFinish = (values) => {
    getLogs(values);
  };
  return (
    <Collapse defaultActiveKey={['1']} style={{ marginBottom: 20 }}>
      <Panel header="Paramètres de recherche" key="1">
        <Form
          form={form}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinish}>
          {getFields()}
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <span style={{ color: '#1DA57A', marginRight: 8 }}>
                {resultsNumber}
              </span>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}>
                Rechercher
              </Button>
              <Button
                style={{ margin: '0 8px' }}
                disabled={loading}
                onClick={() => {
                  form.resetFields();
                  reset();
                }}>
                Reset
              </Button>
            </Col>
          </Row>
        </Form>
      </Panel>
    </Collapse>
  );
};

export default FilterLogs;
